<template lang="pug">
.hover-wrapper(v-if="matchedHolidays.length > 0" :style="{ left: mousePos.x + 'px', top: mousePos.y + 'px' }")
  .ro-wrapper(v-for="matchedHoliday in matchedHolidays")
    .msg {{matchedHoliday.name}} ({{matchedHoliday.state}})
</template>

<script>
import { DateTime } from "luxon";
export default {
  props: {
    matchedHolidays: {
      type: Array
    },
    mousePos: {
      type: Object,
      default() {
        return {
          x: 0,
          y: 0
        }
      }
    }
  },
  computed: {},
  methods: {
    formatDate(d) {
      const dt = DateTime.fromISO(d);
      return dt.setLocale('de')
        .toFormat("dd.LL.yyyy")
    }
  },
}
</script>

<style lang="scss" scoped>
.hover-wrapper {
  user-select: none;
  pointer-events: none;
  position: absolute;
  transform: translate(-50%, 0);
  margin-top: 12px;
  background-color: $black;
  color: white;
  padding: 4px 12px;
  border-radius: 3px;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;
  z-index: 3;
  .ro-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .msg {
    white-space: nowrap;
  }
}
</style>